const FOOTBALL = {
  theme: "pitch",
  themeColor: "#050A08",
  fan: "torcedor",
  splash: ["Futebol", "na palma", "da mão."],
  ticker: ["Brasileirão", "Libertadores", "Copa do Brasil", "Mercado da bola", "Escalações", "Bastidores", "Alertas de gol"],
  perks: [
    "Alertas de gol em tempo real",
    "Escalações e bastidores em primeira mão",
    "Notícias do seu time sem anúncios",
    "Sem fidelidade: cancele quando quiser",
  ],
  video: { webm: "/media/welcome.webm", mp4: "/media/welcome.mp4", poster: "/media/poster.jpg" },
  priceImg: "/media/stadium.jpg",
};

// WhatsApp-style sales funnel (chat opens with the visitor's "Olá, desejo ativar meu App!").
const WA = { wa: true, theme: "zap", themeColor: "#008069" };

export const BRANDS = {
  futmobplus: {
    ...FOOTBALL,
    id: "futmobplus",
    name: "Futmob Plus",
    handle: "@futmobplus",
    logo: "/media/logo.png",
    mark: "/media/logo.png",
    logoRound: false,
    favicon: "/favicon.png",
    touchIcon: "/logo192.png",
    manifest: "/manifest.webmanifest",
    home: "/",
    support: "/atendimento",
    storageKey: "futmob_live_chat_v1",
    ...WA,
  },
  futzap: {
    ...FOOTBALL,
    id: "futzap",
    name: "Futzap",
    handle: "@futzap",
    logo: "/media/futzap/logo.png",
    mark: "/media/futzap/logo.png",
    logoRound: true,
    favicon: "/media/futzap/favicon.png",
    touchIcon: "/media/futzap/icon-192.png",
    manifest: "/futzap.webmanifest",
    home: "/futzap",
    support: "/futzap/atendimento",
    storageKey: "futmob_live_chat_v1_futzap",
    ...WA,
  },
  pipoca: {
    id: "pipoca",
    name: "Universo Pipoca",
    handle: "@universopipoca",
    theme: "pipoca",
    themeColor: "#050A1F",
    fan: "maratonista",
    splash: ["Filmes,", "séries e", "pipoca."],
    ticker: ["Filmes", "Séries", "Doramas", "Lançamentos", "Animes", "Documentários", "Maratonas", "Infantil"],
    perks: [
      "Filmes, séries e doramas num só lugar",
      "Lançamentos e novidades toda semana",
      "Assista no celular, na TV ou no tablet",
      "Sem fidelidade: cancele quando quiser",
    ],
    video: { webm: "/media/pipoca/welcome.webm", mp4: "/media/pipoca/welcome.mp4", poster: "/media/poster.jpg" },
    priceImg: "/media/pipoca/price.jpg",
    logo: "/media/pipoca/logo.png",
    mark: "/media/pipoca/mark.png",
    logoRound: true,
    favicon: "/media/pipoca/favicon.png",
    touchIcon: "/media/pipoca/icon-192.png",
    manifest: "/pipoca.webmanifest",
    home: "/pipoca",
    support: "/pipoca/atendimento",
    storageKey: "futmob_live_chat_v1_pipoca",
    ...WA,
  },
  suporte: {
    id: "suporte",
    name: "Atendimento de Suporte",
    subtitle: "FUTZAP - FUTMOB - WEPLAY - PIPOCA",
    handle: "@centraldeatendimento",
    theme: "zap",
    themeColor: "#008069",
    neutral: true,
    clientOnly: true,
    fan: "",
    intro: "Olá! Aqui é a Bia, do Atendimento de Suporte. Que bom ter você por aqui!",
    script: [
      { type: "text", text: "Olá! Aqui é a Bia, do Atendimento de Suporte." },
      { type: "text", text: "Este canal é exclusivo para clientes Futzap, Futmob, WePlay e Pipoca. Vou te ajudar com acesso, pagamento, renovação ou qualquer dúvida." },
      { type: "install", text: "Dica: instale o app de suporte no seu celular. Assim você fala com a gente em um toque e recebe aviso assim que respondermos." },
    ],
    farewell: "Tudo bem! Obrigada pela visita. Se mudar de ideia, é só voltar aqui. Um abraço da nossa equipe!",
    official: "Atendimento oficial e seguro.",
    splash: ["Suporte", "para", "clientes."],
    ticker: ["Suporte ao cliente", "Futzap", "Futmob", "WePlay", "Pipoca", "Ajuda com acesso", "Pagamentos", "Renovação"],
    perks: [
      "Acesso imediato após a confirmação",
      "Atendimento rápido com pessoas de verdade",
      "Pagamento seguro",
      "Sem fidelidade: cancele quando quiser",
    ],
    video: { webm: "/media/suporte/welcome.webm", mp4: "/media/suporte/welcome.mp4", poster: "/media/poster.jpg" },
    priceImg: null,
    logo: "/media/suporte/logo.png",
    mark: "/media/suporte/mark.png",
    logoRound: true,
    favicon: "/media/suporte/favicon.png",
    touchIcon: "/media/suporte/icon-192.png",
    manifest: "/suporte.webmanifest",
    home: "/suporte",
    support: "/suporte/atendimento",
    storageKey: "futmob_live_chat_v1_suporte",
  },
};

export const DEFAULT_BRAND = BRANDS.futmobplus;
